import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return toast.error("Las contraseñas no coinciden");
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Contraseña restablecida. Inicia sesión.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background grid-bg">
      <div className="w-full max-w-md bg-card border border-border rounded-md p-8">
        <div className="overline mb-2">Cambiar contraseña</div>
        <h1 className="text-3xl font-black tracking-tight mb-6">Nueva contraseña</h1>
        {!token ? (
          <div className="text-sm">Token inválido. <Link to="/forgot-password" className="text-primary underline">Solicitar nuevo</Link></div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4" data-testid="reset-form">
            <div>
              <Label className="text-xs font-bold tracking-wider uppercase">Nueva contraseña</Label>
              <Input
                type="password"
                minLength={8}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1.5"
                data-testid="reset-password-input"
              />
            </div>
            <div>
              <Label className="text-xs font-bold tracking-wider uppercase">Confirmar</Label>
              <Input
                type="password"
                minLength={8}
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                className="mt-1.5"
                data-testid="reset-confirm-input"
              />
            </div>
            <Button
              type="submit"
              className="w-full h-11 bg-primary font-bold"
              disabled={submitting}
              data-testid="reset-submit-btn"
            >
              {submitting ? "Procesando…" : "Restablecer"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
